"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  learnRecord: {
    testResults: '考试情况',
    learningTasks: '学习任务',
    workTasks: '工作任务',
    taskType: '任务类型',
    myTaskQuery: '我的任务查询',
    startTest: '是否开始考试',
    verifFile: '请先补充附件',
    verifTest: '请先完成考试',
    learnDetail: {
      post: '岗位',
      learnDeatil: '学习状态',
      studyDate: '学习日期',
      name: '姓名',
      learningSituation: '人员学习情况'
    }
  }
};